import React from "react";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../utils/withRouter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Search from "../../../../components/Search";
import Table from "../../../../components/Table";
import OCR from "../../../../components/OCR";
import RecordsImportModal from "./components/recordsImportModal";
import CsvUploader from "./components/uploadCSV";
import { dialog } from "../../../../nq-component";
import schema from "./components/RecordDialogModal/schema.json";
import ConfirmationDialog from "../../../../components/ConfirmationDialog/ConfirmationDialog";
import createPromise from "nq-js/dist/createPromise";
import RecordDialogForm from "./components/RecordDialogModal";
import ExcelJS from "exceljs";
import Filters from "./components/Filters";
import { aborted } from "util";
import RecordCompanyListPresenter from "./RecordCompanyListPresenter";

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
class RecordCompanyListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new RecordCompanyListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase(),
    );
    this.state = {
      objects: [],
      selected: [],
      importedData: [],
      isModalOpen: false,
      uploadType: "",
      loading: true,
      total: 0,
      count: 0,
    };

    this.fieldsToDisplay = [
      "lastName",
      "firstName",
      "middleName",
      "company",
      "caseNumber",
      "caseType",
      "branch",
      "plaintiff",
      "courtType",
      "dateFiled",
    ];

    this.debouncedChangeFilter = debounce(this.onChangeFilter.bind(this), 500);
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "records";
  }

  onClickDeleteItem(index) {
    this.presenter.onClickDeleteItem(index);
  }

  saveImportedData(importedData) {
    const uploadType = this.state.uploadType;
    this.presenter.saveImportedData(importedData, uploadType);
  }

  setImportedData(data, uploadType) {
    console.log("dataImport", data);
    this.setState({ importedData: data, uploadType: uploadType });
  }

  toggleModal() {
    this.setState({ isModalOpen: !this.state.isModalOpen });
  }

  setProgress(progress) {
    this.setState({ progress });
  }

  getActions() {
    return [
      {
        label: "Delete",
        onClick: this.onClickDeleteItem.bind(this),
        icon: "bi bi-trash",
        classes: "btn-light",
      },
      {
        label: "Edit",
        onClick: this.onClickItem.bind(this),
        icon: "bi bi-pencil-square",
      },
    ];
  }

  async deleteConfirmation(index) {
    try {
      await this.showConfirmDialog(
        "Are you sure you want to delete this record?",
        "Delete Record",
        "Confirm",
        "Cancel",
      );

      this.onDeleteObject(index);
    } catch {
      console.log("Deletion Cancelled");
    }
  }

  onDeleteObject(indexObject) {
    const { importedData } = this.state;

    const updatedRecords = importedData.filter(
      (data, index) => index !== indexObject,
    );
    this.setState({ importedData: updatedRecords });
    // console.log(updatedRecords);
  }

  handleSubmit(index, object) {
    const { importedData } = this.state;
    const dateFiled = importedData[0].dateFiled;

    let updatedObjects = [...importedData];
    const updatedObject = { ...object, dateFiled: dateFiled };
    if (typeof index === "number") {
      updatedObjects = [
        ...importedData.slice(0, index),
        object,
        ...importedData.slice(index + 1),
      ];
    } else {
      updatedObjects.push(updatedObject);
    }

    this.setState({ importedData: updatedObjects });

    dialog.close();
  }

  onClickEdit(index, selectedObject) {
    dialog.fire({
      html: (
        <RecordDialogForm
          index={index}
          object={selectedObject}
          handleSubmit={this.handleSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  // onDownloadFormat() {
  //   const headers = [
  //     "LAST NAME",
  //     "FIRST NAME",
  //     "MIDDLE NAME",
  //     "ALIAS",
  //     "COMPANY",
  //     "PLAINTIFF",
  //     "CASE NO",
  //     "CASE TYPE",
  //     "BRANCH",
  //     "TYPE OF COURT",
  //     "CITY",
  //     "DATE FILED",
  //   ];

  //   const csvContent = headers.join(",") + "\n"; // Just headers, no data
  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const url = URL.createObjectURL(blob);

  //   const link = document.createElement("a");
  //   link.setAttribute("href", url);
  //   link.setAttribute("download", "record_upload_template.xlsx");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // }

  async onDownloadFormat() {
    // Define headers (and column widths)
    const columns = [
      { header: "LAST NAME", key: "lastName", width: 20 },
      { header: "FIRST NAME", key: "firstName", width: 20 },
      { header: "MIDDLE NAME", key: "middleName", width: 20 },
      { header: "ALIAS", key: "alias", width: 16 },
      { header: "COMPANY", key: "company", width: 24 },
      { header: "PLAINTIFF", key: "plaintiff", width: 24 },
      { header: "CASE NO", key: "caseNumber", width: 18 },
      { header: "CASE TYPE", key: "caseType", width: 18 },
      { header: "BRANCH", key: "branch", width: 16 },
      { header: "TYPE OF COURT", key: "courtType", width: 20 },
      { header: "CITY", key: "city", width: 16 },
      { header: "DATE FILED", key: "dateFiled", width: 18 },
    ];

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Records");

    // Columns + header row
    ws.columns = columns;

    // Freeze header row
    ws.views = [{ state: "frozen", ySplit: 1 }];

    // AutoFilter across the header row (shows the ▼ filter icons)
    ws.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: 1, column: columns.length },
    };

    // Style header like your screenshot: bold, dark fill, white text, centered
    const headerRow = ws.getRow(1);
    headerRow.height = 22;
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF222222" }, // dark gray/near black
      };
      cell.border = {
        top: { style: "thin", color: { argb: "FF444444" } },
        left: { style: "thin", color: { argb: "FF444444" } },
        bottom: { style: "thin", color: { argb: "FF444444" } },
        right: { style: "thin", color: { argb: "FF444444" } },
      };
    });

    // Optionally add an example empty row so users see the format (keeps sheet not totally blank)
    ws.addRow({}); // data rows can be appended later by your importer

    // Generate and download
    const buf = await wb.xlsx.writeBuffer();
    const blob = new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "record_upload_template.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  searchSubmit(where, merge) {
    this.presenter.searchSubmit(where, merge);
  }

  filterSubmit(where) {
    this.presenter.filterSubmit(where);
  }

  onChangeFilter(type, value, field) {
    console.log(typeof value);

    const where = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        }
        break;
      case "Date":
        where[field] = {
          $eq: value,
        };
        break;
      case "Boolean":
        where[field] = value;
        break;
      default: {
        const pattern =
          typeof value === "string"
            ? value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
            : value;
        where[field] = { $regex: pattern, $options: "i" };
      }
    }
    this.filterSubmit(where);
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, importedData } = this.state;

    // console.log(importedData);
    // console.log(schema);
    // console.log("importedData", importedData);
    // console.warn("objects", objects);
    return (
      <PageContainer
        title="Records Company"
        buttonHandler={this.onClickAdd.bind(this)}
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <div className="w-100 d-flex gap-5 align-items-center justify-content-between">
          <RecordsImportModal
            importedData={this.state.importedData}
            saveImportedData={this.saveImportedData.bind(this)}
            isModalOpen={this.state.isModalOpen}
            toggleModal={this.toggleModal.bind(this)}
            onDelete={this.deleteConfirmation.bind(this)}
            onEdit={this.onClickEdit.bind(this)}
          />
          <div className="d-flex flex-column col-12">
            {/* <Search
            schemas={this.getSchemas()}
            className="w-50"
            onSubmit={this.searchSubmit.bind(this)}
            fields={schema.fields}
          /> */}
            {/* <div className="d-flex flex-row align-items-center gap-2 align-self-end">
              <button
                className="btn text-white fw-medium"
                style={{ backgroundColor: "green", fontSize: ".875rem" }}
                onClick={() => this.onDownloadFormat()}
              >
                <i class="bi bi-filetype-csv me-2"></i>
                CSV format
              </button>
              <CsvUploader
                setImportedData={(data) =>
                  this.setImportedData(data, "isScannedCSV")
                }
                toggleModal={this.toggleModal.bind(this)}
              />
              <OCR
                setImportedData={(data) =>
                  this.setImportedData(data, "isScannedPDF")
                }
                toggleModal={this.toggleModal.bind(this)}
                setProgress={this.setProgress.bind(this)}
              />
            </div> */}

            <Filters onChangeFilter={this.debouncedChangeFilter} />
          </div>
        </div>
        <div className="d-flex justify-content-end fw-normal">
          <p className="m-0">
            Total {objects.length} of {count}
          </p>
        </div>
        <Table
          fields={schema.fields}
          objects={objects}
          collapsable
          progress={loading}
          actions={this.getActions.bind(this)}
          excludeFields={Object.keys(schema.fields).filter(
            (key) => !this.fieldsToDisplay.includes(key),
          )}
        />
      </PageContainer>
    );
  }
}

export default withRouter(RecordCompanyListPage);
